@media (hover: hover) {
	.prism-code-editor::-webkit-scrollbar-corner,
	.prism-code-editor::-webkit-scrollbar-track,
	.prism-code-editor ::-webkit-scrollbar-corner,
	.prism-code-editor ::-webkit-scrollbar-track {
		background: #0000;
	}
	.prism-code-editor::-webkit-scrollbar,
	.prism-code-editor ::-webkit-scrollbar {
		height: 1em;
		width: 1em;
	}
	.prism-code-editor::-webkit-scrollbar-thumb,
	.prism-code-editor ::-webkit-scrollbar-thumb {
		background: hsla(var(--pce-scrollbar), 0.36);
		width: 2em;
		height: 2em;
	}
	.prism-code-editor::-webkit-scrollbar-thumb:hover,
	.prism-code-editor ::-webkit-scrollbar-thumb:hover {
		background: hsla(var(--pce-scrollbar), 0.5);
	}
	.prism-code-editor::-webkit-scrollbar-thumb:active,
	.prism-code-editor ::-webkit-scrollbar-thumb:active {
		background: hsla(var(--pce-scrollbar), 0.66);
	}
}
